import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      _tempForm: null
    }
  },
  computed: {
    ...mapGetters(['form']),
    group () {
      const self = this
      let group = self.form.allGroups.find((group) => {
        return group.id === self.groupKey
      })
      return group
    }
  },
  mounted () {
  },
  methods: {
    calculateForm (form) {
      const self = this

      self._tempForm = form
      self._tempForm.allAreas.forEach((area) => {
        area.valid = false
      })
      self._tempForm.valid = false

      return new Promise((resolve, reject) => {
        self.calculateAreas(form).then((form) => {
          self.calculateModules(form).then((form) => {
            resolve(form)
          })
        })
      })
    },
    calculateModules (form) {
      const self = this
      return new Promise((resolve, reject) => {
        let tempHolder = {}
        self._tempForm.allModules.forEach((module) => {
          if (!tempHolder.hasOwnProperty(module.key)) {
            tempHolder[module.key] = {}
          }
          tempHolder[module.key][module.id] = module.selected
        })

        self._tempForm.allModules.forEach((module) => {
          module.selectInOther = null
          if (tempHolder.hasOwnProperty(module.key)) {
            let obj = tempHolder[module.key]
            Object.keys(obj).forEach((key, index) => {
              if (key !== module.id && obj[key] === true) {
                module.selectInOther = key
              }
            })
          }
        })
        resolve(self._tempForm)
      })
    },
    calculateAreas (form) {
      const self = this
      return new Promise((resolve, reject) => {
        if (form.hasOwnProperty('areas')) {
          form.areas.forEach((areaKey) => {
            let area = self.getAreaById(areaKey)
            self.calculateArea(area).then((areaResult) => {
            })
          })
          resolve(self._tempForm)
        }
        else {
          resolve(self._tempForm)
        }
      })
    },

    /**
     * return the new group
     * @param group
     * @returns {Promise|Promise}
     */
    calculateArea (area) {
      const self = this
      return new Promise((resolve, reject) => {
        area.valid = true
        // check areas before
        if (area.hasOwnProperty('areas') && area.areas.length > 0) {
          area.areas.forEach((areaId) => {
            let a = self.getAreaById(areaId)
            self.calculateArea(a)
          })
        }

        let selected = 0

        area.submodules.forEach((moduleId) => {
          let module = self.getModuleById(moduleId)
          if (module.selected) {
            selected++
          }
        })
        area.selectedModules = selected

        area.validators.forEach((validator, index) => {
          validator.valid = true
          if (validator.key === 'max') {
            if (selected > parseInt(validator.value)) {
              validator.valid = false
              area.valid = false
            }
          }
          if (validator.key === 'min') {
            if (selected < parseInt(validator.value)) {
              validator.valid = false
              area.valid = false
            }
          }
        })

        // all sub groups valid?
        if (area.hasOwnProperty('areas') && area.areas.length > 0) {
          area.areas.forEach((areaId) => {
            let g = self.getAreaById(areaId)
            if (g.valid === false) {
              area.valid = false
            }
          })
        }

        resolve(area)
      })
    },
    getAreaById (id) {
      const self = this
      return self._tempForm.allAreas.find((group) => {
        return group.id === id
      })
    },
    getModuleById (id) {
      const self = this
      return self._tempForm.allModules.find((module) => {
        return module.id === id
      })
    },
    isModuleSelected (key) {
      return this.getModuleById(key).selected
    }
  }
}
